import React, { useEffect, useRef, useState } from "react";
import { Modal, Spinner } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import "./pdf-language-modal.scss";
export default function PdfLanguageModal({ show, onHide, onGenerate }: { show: boolean; onHide: () => void; onGenerate: (language: "he" | "en") => Promise<void> }) {
  const { t } = useTranslation("interface");
  const pending = useRef(false);
  const [busy, setBusy] = useState(false), [error, setError] = useState(false);
  useEffect(() => { if (show) { pending.current = false; setBusy(false); setError(false); } }, [show]);
  const generate = async (language: "he" | "en") => {
    if (pending.current) return;
    pending.current = true; setBusy(true); setError(false);
    try { await onGenerate(language); onHide(); }
    catch { pending.current = false; setError(true); }
    finally { setBusy(false); }
  };
  return <Modal show={show} onHide={() => { if (!pending.current) onHide(); }} centered keyboard={!busy} backdrop={busy ? "static" : true} dialogClassName="pdf-language-dialog" aria-labelledby="pdf-language-title">
    <Modal.Header closeButton={!busy}><Modal.Title id="pdf-language-title">{t("Choose PDF language")}</Modal.Title></Modal.Header>
    <Modal.Body>
      {error && <p role="alert" className="text-danger">{t("PDF generation failed")}</p>}
      {busy && <p role="status"><Spinner as="span" animation="border" size="sm" /> {t("Preparing PDF")}</p>}
      <div className="pdf-language-actions">
        <button type="button" disabled={busy} onClick={() => generate("he")}>עברית / Hebrew</button>
        <button type="button" disabled={busy} onClick={() => generate("en")}>English / אנגלית</button>
      </div>
    </Modal.Body>
    <Modal.Footer><button type="button" disabled={busy} onClick={onHide}>{t("Cancel PDF download")}</button></Modal.Footer>
  </Modal>;
}
